<div>
  <h1 mat-dialog-title>Revisione Itinerario</h1>
  <span fxFlex></span>
  <button
    mat-icon-button
    aria-label="Chiudi"
    [mat-dialog-close]
    class="mat-dialog-close"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <p>
    Sei veramente sicuro di avviare la revisione?
    <br />Una volta avviata la revisione l'itinerario non potrà più essere
    modificato fino a quando la revisione non sarà conclusa.
  </p>
  <p>
    <mat-checkbox [(ngModel)]="isPreviewChecked" cdkFocusInitial
      >Ho controllato l'itinerario tramite la funzione “Anteprima” e dichiaro
      che non vi sono difetti grafici e la resa è ottimale.</mat-checkbox
    >
  </p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]>
    Annulla
  </button>
  <span fxFlex></span>
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="true"
    cdkFocusInitial
    *ngIf="isPreviewChecked"
  >
    Ok, Procedi
  </button>
</div>
